import React, { Component } from 'react'

/* Components */
import HomeView from './HomeView'

class Home extends Component {
    constructor(props){
        super(props)
        this.state = { }
    }

    render(){
        return(
            <HomeView />
        )
    }
}

export default Home